import { atom } from 'jotai';

export const testModeAtom = atom<TestMode>('answer');
